enum FishbowlQueueTypeEnum {
    SALES_ORDERS = "SALES_ORDERS",
    SHIPMENTS = "SHIPMENTS",
    PULL_INVENTORY = "PULL_INVENTORY",
    PULL_CUSTOMERS = "PULL_CUSTOMERS",
}

export default FishbowlQueueTypeEnum;
